import { React, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TextField, Typography, Container, Button, Box } from "@mui/material";

// page for managers to create a new staf members account
export default function SignUp() {

	const [formData, setFormData] = useState({});
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		try {
			e.preventDefault();
			setLoading(true);

			const result = await fetch('/sign-up',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(formData),
				}
			);
			
			const data = await result.json();

			if (data.status_code !== 201) {
				setLoading(false);
				setError(data.message);
				return;
			}
			setLoading(false);
			setError(null);
			navigate('/sign-in');
		} catch(err) { 
			setLoading(false);
			setError(err.message);
		}
	};

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.id]: e.target.value,
		});
	};

	return (
		<>
			<Container sx={{ display: 'flex', justifyContent: 'center',  flexDirection: 'row', flexWrap: 'wrap'}}>
				<Box sx={{ display: 'flex', justifyContent: 'center',  flexDirection: 'column', flexWrap: 'wrap', m: 1, padding: 5}}>
					<Typography variant="h5" align="center" sx={{fontWeight:'bold'}}>Staff Sign Up</Typography>
					<form onSubmit={handleSubmit} >
						<div>
							<TextField
								required onChange={handleChange}
								id="employeeId"
								label="Employee ID"
								type="number"
								variant="outlined"
								sx={{mt:2, width: 300}}
							/>
						</div>
							
						<div>
							<TextField
								required onChange={handleChange}
								id="position"
								label="Position"
								type="text"
								variant="outlined"
								sx={{mt:2, width: 300}}
							/>
						</div>
						<div>
							<TextField
								required onChange={handleChange} 
								id="password"
								label="Password"
								type="password"
								variant="outlined"
								sx={{mt:2, width: 300}}
							/>
						</div>
						<Button disabled={loading} onClick={handleSubmit} sx={{ width: 300, mt: 2, backgroundColor: "black", 
							':hover': {
								color: 'black', 
								bgcolor: 'grey'
							} 
						}} size="medium" variant="contained">
							Sign Up
						</Button>
					</form>
					<Box sx={{mt: 2}} align="center">
						<span>Existing employee? </span>
						<Link to={"/sign-in"}>
						<span>Sign In</span>
						</Link>
					</Box>
							{error && <p style={{color: 'red'}}>{error}</p>}

				</Box>
			</Container>

		</>
	);
}